import { CourtColumnSegment } from './court-grid.model';

/** Minutes between two ISO instants (negative if `toIso` precedes `fromIso`). */
export function minutesBetween(fromIso: string, toIso: string): number {
  return (new Date(toIso).getTime() - new Date(fromIso).getTime()) / 60_000;
}

/** ISO instant `minutes` after `isoInstant`. */
export function addMinutesIso(isoInstant: string, minutes: number): string {
  return new Date(new Date(isoInstant).getTime() + minutes * 60_000).toISOString();
}

/**
 * The segment whose [start, end) span contains the given instant.
 *
 * Compares numerically, never as ISO strings: the backend serializes
 * timestamps WITHOUT milliseconds ("...T14:00:00Z") while frontend-synthesized
 * instants (toISOString()) always include them ("...T14:00:00.000Z"), and
 * lexicographic comparison between the two formats is wrong even for the
 * exact same instant ("...00Z" sorts AFTER "...00.000Z" because 'Z' > '.').
 */
export function findSegmentAt(
  segments: CourtColumnSegment[],
  atMs: number,
): CourtColumnSegment | undefined {
  return segments.find(s => {
    const startMs = new Date(s.startTimeUtc).getTime();
    const endMs = new Date(s.endTimeUtc).getTime();
    return startMs <= atMs && atMs < endMs;
  });
}
